import { IRowProps } from "@components/table/Rows.types";
import { ApprovalStatusTypeCode } from "@odata/GeneratedEnums";
import React, { useCallback } from "react";

import { IconSize } from "../../enums";
import FileIconWithStatus from "../../pages/inbox/FileIconWithStatus";
import TestIds from "../../testIds";
import { IconButton } from "../button";
import { EmailIcon } from "../icon";
import { TId } from "../table";
import { WithContextMenu,withContextMenu } from "../table/withContextMenu";
import { FileIconWrapper } from "./FileUploader.styles";

interface IProps extends WithContextMenu {
    rowProps?: IRowProps;
    onClick?: (id?: TId, props?: IRowProps) => void;
    isDisabled?: boolean;
    status?: ApprovalStatusTypeCode;
    hasFile?: boolean;
}

/**
 * Icon button to be used as contentBefore of table in Inbox and FileUploader
 * @constructor
 */
const TableFileIcon: React.FC<IProps> = (props) => {
    const { onClick, id, rowProps } = props;

    const handleClick = useCallback(() => {
        onClick?.(id, rowProps);
    }, [onClick, id, rowProps]);

    return (
        <FileIconWrapper onContextMenu={props.onContextMenu} data-testid={TestIds.FileIconWrapper}>
            <IconButton title={""}
                        isDecorative
                        isDisabled={props.isDisabled}
                        onClick={handleClick}>
                {props.hasFile === false ? (
                    <EmailIcon width={IconSize.M}/>
                ) : (
                    <FileIconWithStatus status={props.status} width={IconSize.M}/>
                )}
            </IconButton>
        </FileIconWrapper>
    );
};

export default withContextMenu(TableFileIcon);